export default __webpack_public_path__ + "static/media/Submitted.1ece0e27.svg";